"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTinymceFullHeight = exports.removeAutoResize = exports.cleanContent = void 0;
const setTinymceFullHeight = iframe => {
  iframe.parentElement.style.flex = 'auto';
  iframe.parentElement.previousElementSibling.style.flex = 'none';
  iframe.parentElement.parentElement.style.height = '100%';
  iframe.parentElement.parentElement.style.display = 'flex';
  iframe.parentElement.parentElement.style.flexDirection = 'column';
  iframe.parentElement.parentElement.parentElement.style.height = '100%';
};
exports.setTinymceFullHeight = setTinymceFullHeight;
const cleanContent = contentEvent => {
  contentEvent.content = contentEvent.content.replace(/\r?\n/g, '<br />');
};
exports.cleanContent = cleanContent;
const removeAutoResize = tinymceOptions => {
  tinymceOptions.resize = false;
  delete tinymceOptions.autoresize_min_height;
  delete tinymceOptions.autoresize_max_height;
  tinymceOptions.plugins = tinymceOptions.plugins.replace('autoresize', '');
};
exports.removeAutoResize = removeAutoResize;